import React, { useEffect, useState } from "react";
import { Modal, ModalBody } from "reactstrap";
import CLoseImg from "../../../assets/images/closeIconModal.svg";
import "../promotion.scss";

interface DeactiveModalProps {
  show: boolean;
  onCloseClick: () => void;
}

const DeactiveModal: React.FC<DeactiveModalProps> = ({
  show,
  onCloseClick,
}) => {
  return (
    <>
      <Modal isOpen={show} centered={true} className="DeactiveModal">
        <ModalBody className="modal_Body">
          <img
            data-testing-id="closeIcon"
            onClick={onCloseClick}
            className="closeIconModal"
            src={CLoseImg}
            alt=""
          />
          <div className="confirm">
            <h1>Confirm </h1>
            <p>Are you sure to deactivate this promotion </p>
            <div className="twoBtn">
              <button className="btn btn-secondary">OK</button>
              <button className="btn danger" onClick={onCloseClick}>Cancel</button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeactiveModal;
